import React, { useState, useRef } from "react";
import {
  DatePicker,
  Form,
  Modal,
  Popover,
  Select,
  message,
  Input,
  InputNumber,
  Pagination,
  Skeleton,
} from "antd";

import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../constants/const";
import { getFromLocalStorage } from "../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../Helpers/DateHelpers";
import { createDropdownValues } from "../../Helpers/helperFunctions";
import Assets from "../Layout/Assets";
import styles from "../InterbranchAdminComponents/RequestedAppointments/index.module.scss";
import {
  FETCH_ADMIN_DASHBOARD_REPORT,
  fetch_doctors_list,
  acceptrejectrequest,
  FETCH_REQUEST_DASHBOARD_REPORT,
  getupdtappoinment,
} from "../../actions/ClinicAdminAction";
import {
  bookingform,
  fetchPatientDetail,
  fetchPatientLovedOne,
  fetchclinicnames,
  fetchconsultation,
  fetchdoctor,
  fetchspecilaity,
  fetchtimezone,
  CheckuserEmailavailbility,
  getdoctorbyspeciality
} from "../../actions/Quickbooking";
import { FETCH_DASHBOARD_MORE } from "../../actions/InterbranchAdminActions";
import "./index.css";
import { color } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "antd";
import { fetchVisitHistory } from "../../actions/ConsultationAction";
import { format, parse } from "date-fns";
import { fetchgangaSpeciality, fetchallSpeciality} from "../../actions/SpecialityListingAction";

function TodaysReportModalContent({ handleTableRefresh }) {
  let requestID = localStorage.getItem("apptid");
  const dispatch = useDispatch();
  let [acceptModal, setAcceptModal] = useState(false);
  let [loader, setloader] = useState(true);
  let [reassignModal, setReassignModal] = useState(false);
  let [rejectModal, setRejectModal] = useState(false);
  let [reAssignData, setReassignData] = useState({});
  let [requestedData, setRequestedData] = useState({});
  let [processdone, setProcessdone] = useState(false);
  let [appointmentDetailsV2, setAppointmentDetailsV2] = useState({});
  let appointmentDetails = useSelector(
    (state) => state.interbranchAdmin.dashboardSelected
  );
  let [visitDetails, setVisitDetails] = useState({});
  const [visitsToShow, setVisitsToShow] = useState(5);
  const [showLessButton, setShowLessButton] = useState(false);

  //let appointmentDetailsV2 = useSelector(state => state.interbranchAdmin)

  useEffect(() => {
    setloader(true); //before API call

    dispatch(FETCH_DASHBOARD_MORE(requestID))
      .then((res) => {
        console.log("resApp", res);
        setAppointmentDetailsV2(res);

        // Check if MRN is available before making the fetchVisitHistory call
        if (res.MRN) {
          dispatch(fetchVisitHistory(res.MRN))
            .then((visitRes) => {
              console.log("visitRes", visitRes);
              setVisitDetails(visitRes);
              setloader(false); //both API calls are completed
            })
            .catch((error) => {
              console.error("Error fetching visit history:", error);
              setloader(false); // Set the loader to false even if there's an error
            });
        } else {
          setloader(false); // Set the loader to false if MRN is not available
        }
      })
      .catch((error) => {
        console.error("Error fetching appointment details:", error);
        setloader(false); // Set the loader to false even if there's an error
      });
  }, [processdone]);
  console.log("visitDetails", visitDetails);

  console.log("appointmentDetails", appointmentDetails.patientId);
  const handleAcceptModalCallBack = () => {
    if (handleTableRefresh) {
      handleTableRefresh();
    }
  };

  const formatVisitDate = (dateString) => {
    if (!dateString) return "";

    // Parse the date string to a Date object
    const date = parse(dateString, "dd-MM-yyyy HH:mm:ss", new Date());

    // Format the date to 'dd-MMM-yyyy'
    const formattedDate = format(date, "dd-MMM-yyyy");

    // Format the time to 'hh:mma'
    const formattedTime = format(date, "hh:mm a").toUpperCase();

    return `${formattedDate}, ${formattedTime}`;
  };

  const toggleAcceptModal = (flag) => setAcceptModal(flag ? flag : false);
  const toggleReassignModal = (flag) => setReassignModal(flag ? flag : false);
  const toggleRejectModal = (flag) => setRejectModal(flag ? flag : false);

  console.log("appointmentDetails", appointmentDetails?.medicines);
  console.log("appointmentDetailsV2", appointmentDetailsV2);

  const loadMoreVisits = () => {
    const newVisitsToShow = visitsToShow + 5;
    setVisitsToShow(newVisitsToShow);

    if (newVisitsToShow >= visitDetails.output.length) {
      setShowLessButton(true);
    }
  };
  const visitHistoryRef = useRef(null);

  const showLessVisits = () => {
    setVisitsToShow(5);
    setShowLessButton(false);
    visitHistoryRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="today-report-modal-content">
      {!loader ? (
        <>
          <div className="header">
            Appointment ID - {appointmentDetails?.appointmentId}
          </div>

          <div className="todays-report-timeline">
            {appointmentDetails?.appointmentStatus != "Completed" && (
              <ActionButtons
                onAccept={() => {
                  setRequestedData(appointmentDetails);
                  toggleAcceptModal(true);
                }}
              />
            )}
            <table className="todays_report_table">
              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Appointment Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Appointment ID</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.appointmentId}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Appointment Date & Time</td>

                  <td className="cell3 even">
                    {appointmentDetailsV2?.appointmentDatetime}
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 odd">Department Name</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.specialityName || "NA"}
                  </td>
                </tr> */}

                <tr>
                  <td className="cell1 odd">Duration</td>

                  <td className="cell3 odd">
                    {appointmentDetailsV2?.duration}
                  </td>
                </tr>
                {appointmentDetailsV2?.isrescheduled != undefined &&
                  appointmentDetailsV2?.isrescheduled === "true" &&
                  appointmentDetailsV2?.previousbookingDate != undefined && (
                    <>
                      <tr>
                        <td className="cell1 odd">
                          Prev.Appointment Date & Time
                        </td>

                        <td className="cell3 odd">
                          {appointmentDetailsV2?.previousbookingDate}
                        </td>
                      </tr>
                      <tr>
                        <td className="cell1 odd">Prev duration</td>

                        <td className="cell3 odd">
                          {appointmentDetailsV2?.oldduration}
                        </td>
                      </tr>
                      <tr>
                        <td className="cell1 even">Prev Doctor Name</td>
                        <td className="cell3 even">
                          {appointmentDetailsV2?.DoctorName || "NA"}
                        </td>
                      </tr>
                      <tr>
                        <td className="cell1 even">Rescheduled by</td>
                        <td className="cell3 even">
                          {appointmentDetailsV2?.rescheduledbyName +
                            " (" +
                            appointmentDetailsV2?.rescheduledby +
                            ") " || "NA"}
                        </td>
                      </tr>
                    </>
                  )}
                {appointmentDetails?.appointmentStatus != "Upcoming" &&
                  appointmentDetailsV2?.rating != "NA" &&
                  appointmentDetailsV2?.rating != "0" && (
                    <tr>
                      <td className="cell1 even">Rating</td>
                      <td className="cell3 even">
                        {appointmentDetailsV2?.rating != "NA" &&
                        appointmentDetailsV2?.rating != "0"
                          ? appointmentDetailsV2?.rating + " Stars"
                          : "NA"}
                      </td>
                    </tr>
                  )}
                {appointmentDetails?.appointmentStatus != "Upcoming" &&
                  appointmentDetailsV2?.reviewcomments != "" && (
                    <tr>
                      <td className="cell1 even">Feedback Comments</td>
                      <td className="cell3 even">
                        {appointmentDetailsV2?.reviewcomments != ""
                          ? appointmentDetailsV2?.reviewcomments
                          : "NA"}
                      </td>
                    </tr>
                  )}

                {/* <tr>
                            <td className='cell1 even'>Booked from</td>

                            <td className='cell3 even'>{appointmentDetailsV2?.booked_from!="-"?appointmentDetailsV2?.booked_from:"NA"}</td>
                        </tr> */}

                <tr>
                  <td className="cell1 even">Patient consent</td>

                  <td className="cell3 even">
                    {appointmentDetails?.consent != "" &&
                    appointmentDetails?.consent != "-" ? (
                      <a href={appointmentDetails?.consent} target="_blank">
                        Consent
                      </a>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Prescription File</td>
                  <td className="cell3 even">
                    {appointmentDetails?.medicines &&
                    appointmentDetails?.medicines !== "Not Available" &&
                    appointmentDetails?.medicines !== "-" ? (
                      <a
                        href={appointmentDetails?.medicines}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Prescription
                      </a>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Patient Health info</td>
                  <td className="cell3 even">
                    {appointmentDetails?.healthfile &&
                    appointmentDetails?.healthfile !== "Not Available" &&
                    appointmentDetails?.healthfile !== "-" ? (
                      <a
                        href={appointmentDetails?.healthfile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Health Info
                      </a>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
              </tbody>

              {Array.isArray(visitDetails.output) &&
                visitDetails.output.length > 0 && (
                  <tbody ref={visitHistoryRef}>
                    <tr>
                      <td className="title" colSpan={2}>
                        Visit History{" "}
                        <span style={{ fontWeight: "normal" }}>
                          ({visitDetails.output.length})
                        </span>
                      </td>
                    </tr>

                    {visitDetails.output
                      .slice()
                      .sort(
                        (a, b) => new Date(b.VisitDate) - new Date(a.VisitDate)
                      )
                      .slice(0, visitsToShow)
                      .map((visit, index) => (
                        <tr key={index}>
                          <td className="cell1 even" colSpan={3}>
                            <ul
                              style={{ marginBottom: "0", paddingLeft: "12px" }}
                            >
                              <li>
                                {formatVisitDate(visit?.VisitDate)}
                                <p
                                  className="cell3 even"
                                  style={{ marginBottom: "0" }}
                                >
                                  <div>
                                    {visit?.Doctor}, {visit?.Visit}/
                                    {visit?.Location}
                                  </div>
                                </p>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {visitsToShow < visitDetails.output.length && (
                      <tr
                        style={{
                          // display: "flex",
                          float: "right",
                          marginRight: "-227px",
                          // position: "relative",
                          marginTop: "-20px",
                        }}
                      >
                        <td
                          colSpan={2}
                          // style={{ position: "absolute", marginTop: "-60px", marginLeft:"159px"}}
                        >
                          <a
                            // href="#"
                            onClick={loadMoreVisits}
                            // style={{ width: "100px", marginLeft: "130px" }}
                          >
                            <div style={{ color: "rgb(64, 169, 255)" }}>
                              Load More &gt;&gt;
                            </div>
                          </a>{" "}
                        </td>
                      </tr>
                    )}
                    {showLessButton && (
                      <tr
                        style={{
                          // display: "flex",
                          float: "right",
                          marginRight: "-227px",
                          // position: "relative",
                          marginTop: "-20px",
                        }}
                      >
                        <td colSpan={2}>
                          <a onClick={showLessVisits}>
                            <div style={{ color: "rgb(64, 169, 255)" }}>
                              Show Less &lt;&lt;
                            </div>
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}

              {!Array.isArray(visitDetails.output) &&
                visitDetails.output &&
                Object.keys(visitDetails.output).length > 0 && (
                  <tbody>
                    {" "}
                    <tr>
                      {" "}
                      <td className="title" colSpan={2}>
                        {" "}
                        Visit History{" "}
                        <span style={{ fontWeight: "normal" }}>(1)</span>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td className="cell1 even" colSpan={3}>
                        {" "}
                        <ul style={{ marginBottom: "0", paddingLeft: "12px" }}>
                          {" "}
                          <li>
                            {" "}
                            {formatVisitDate(
                              visitDetails.output.VisitDate
                            )}{" "}
                            <p
                              className="cell3 even"
                              style={{ marginBottom: "0" }}
                            >
                              {" "}
                              <div>
                                {" "}
                                {visitDetails.output.Doctor},{" "}
                                {visitDetails.output.Visit}/
                                {visitDetails.output.Location}{" "}
                              </div>{" "}
                            </p>{" "}
                          </li>{" "}
                        </ul>{" "}
                      </td>{" "}
                    </tr>{" "}
                  </tbody>
                )}

              {appointmentDetailsV2 &&
                appointmentDetails.adminbookedby !== "admin" && (
                  <tbody>
                    <>
                      <tr>
                        <td className="title" colSpan={2}>
                          Timeline
                          <p
                            className="title"
                            style={{
                              float: "right",
                              marginTop: "0px",
                              marginBottom: "0px",
                            }}
                          >
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "TAT is calculated from the time the appointment request is received."
                              }
                            >
                              <InfoOutlinedIcon
                                style={{
                                  color: "#69359b",
                                  fontSize: "1.5em",
                                  cursor: "pointer",
                                  marginLeft: "120px",
                                }}
                              />
                            </Tooltip>
                          </p>
                        </td>
                      </tr>

                      <tr>
                        {appointmentDetailsV2?.requestedDatetime && (
                          <td className="cell1 even" colSpan={3}>
                            <ul
                              style={{ marginBottom: "0", paddingLeft: "12px" }}
                            >
                              <li>
                                Appointment Requested Date & Time
                                <p
                                  className="cell3 even"
                                  style={{ marginBottom: "0" }}
                                >
                                  <div>
                                    {appointmentDetailsV2?.requestedDatetime}
                                  </div>
                                </p>
                              </li>
                            </ul>
                          </td>
                        )}
                      </tr>
                      {appointmentDetailsV2?.statusupdates !== undefined &&
                        appointmentDetailsV2?.statusupdates?.length > 0 && (
                          <tr>
                            <td className="cell1 even" colSpan={3}>
                              <ul
                                style={{
                                  marginBottom: "0",
                                  paddingLeft: "12px",
                                }}
                                className="statuslist"
                              >
                                {appointmentDetailsV2.statusupdates.map(
                                  (item, index) => (
                                    <li>
                                      Appointment Reviewed
                                      <p
                                        className="cell3 even"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <div>{item?.reason}</div>

                                        <p style={{ marginBottom: "0" }}>
                                          {item?.actiontakenTime}
                                        </p>
                                      </p>
                                    </li>
                                  )
                                )}
                              </ul>
                            </td>
                          </tr>
                        )}
                      {appointmentDetailsV2?.acceptedDatetime && (
                        <tr>
                          <td className="cell1 even">
                            <ul
                              style={{ marginBottom: "0", paddingLeft: "12px" }}
                            >
                              <li>
                                Booked
                                <p
                                  className="cell3 even"
                                  style={{ marginBottom: "0" }}
                                >
                                  <>
                                    <div>
                                      {appointmentDetailsV2?.acceptedDatetime ||
                                        "NA"}
                                    </div>
                                    <span>
                                      {`TAT - ${
                                        !appointmentDetailsV2?.elapsedTime?.includes(
                                          "0 hours"
                                        ) &&
                                        !appointmentDetailsV2?.elapsedTime?.includes(
                                          "0 minutes"
                                        ) &&
                                        !appointmentDetailsV2?.elapsedTime?.includes(
                                          "minutes"
                                        )
                                          ? appointmentDetailsV2?.elapsedTime
                                          : appointmentDetailsV2?.elapsedTime
                                              ?.replace("0 hours, ", "")
                                              ?.replace("hours, ", "hours")
                                              ?.replace("0 minutes", "")
                                              ?.replace(/\s*\d+\s*minutes?/, "")
                                              .replace(/, $/, "")
                                      }`}
                                    </span>
                                  </>
                                </p>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                )}
              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Patient Complaint
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    {" "}
                    {appointmentDetails?.notes != "-"
                      ? appointmentDetails?.notes
                      : "NA"}{" "}
                  </td>
                </tr>
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Consultation Status
                    <p
                      className="title"
                      style={{
                        float: "right",
                        marginTop: "0px",
                        marginBottom: "0px",
                      }}
                    >
                      <Tooltip
                        overlayStyle={{ maxWidth: "500px" }}
                        placement="bottomRight"
                        title={
                          <React.Fragment>
                            <strong>Doctor & Patient No-show:</strong> If doctor
                            and patient not joined
                            <br />
                            <strong> Upcoming:</strong> Before consultation time
                            upcoming
                            <br />
                            <strong>Completed:</strong> Doctor ends the
                            consultation
                            <br />
                            <strong>Apmt Time Completed:</strong> If duration
                            completed
                            <br />
                            <strong>Cancelled by Patient:</strong> If patient
                            cancelled the consultation
                            <br />
                            <strong>Cancelled by Doctor:</strong> If Doctor
                            cancelled the consultation
                            <br />
                            <strong>Doctor Unavailable:</strong> If Doctor
                            unavailable for consultation
                            <br />
                            <strong>Doctor Unavailable:</strong> If Patient
                            unavailable for consultation
                            <br />
                            <strong>Technical Error - Doctor:</strong> If doctor
                            have Technical errors for consultation
                            <br />
                            <strong>Technical Error - Patient:</strong> If
                            patient have Technical error for consultation
                          </React.Fragment>
                        }
                      >
                        <InfoOutlinedIcon
                          style={{
                            color: "#69359b",
                            fontSize: "1.5em",
                            cursor: "pointer",
                            marginLeft: "120px",
                          }}
                        />
                      </Tooltip>
                    </p>
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Status</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.appointmentStatus}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Session ID</td>

                  <td className="cell3 even">
                    {appointmentDetails?.sessionId}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">
                    Patient Availability and On Screen Status
                  </td>

                  <td className="cell3 odd">
                    {appointmentDetails?.PatientScreenStatus}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">
                    Doctor Availability and On Screen Status
                  </td>

                  <td className="cell3 even">
                    {appointmentDetails?.DoctorScreenStatus}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Appointment Duration</td>

                  <td className="cell3 odd">{appointmentDetails?.duration}</td>
                </tr>
                <tr>
                  <td className="cell1 odd">Type of Consultation</td>

                  <td className="cell3 odd">
                    {appointmentDetailsV2?.typeOfConsultation}
                  </td>
                </tr>
              </tbody>

              {/* <tbody>

                        <tr>
                            <td className='title' colSpan={2}>Notifications Details</td>

                        </tr>


                        <tr>

                            <td className='cell1 odd'>Patient</td>

                            <td className='cell3 odd'>

                                Email sent date: {appointmentDetailsV2?.emailPatientDate}<br />
                                Email sent time: {appointmentDetailsV2?.emailPatientTime} <br />
                            </td>
                        </tr>

                        <tr>
                            <td className='cell1 even'>Doctor</td>

                            <td className='cell3 even'>
                                Email sent date: {appointmentDetailsV2?.emailDoctorDate} <br />
                                Email sent time: {appointmentDetailsV2?.emailDoctorTime} <br />
                            </td>
                        </tr>


                    </tbody> */}

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Patient Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Name</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.patientname}
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 even">New/Existing</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.NewOrExisting}
                  </td>
                </tr> */}

                <tr>
                  <td className="cell1 odd">MRN Number</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.Hospitalid != undefined &&
                    appointmentDetails?.Hospitalid != "-"
                      ? appointmentDetails?.Hospitalid
                      : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Location</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.PatientLocation || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Email ID</td>
                  <td className="cell3 odd">
                    {appointmentDetailsV2?.PatientEmail}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Phone Number</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.PatientMobile}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Timezone</td>
                  <td className="cell3 odd">
                    {appointmentDetailsV2?.PatientTimeZone}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Booked By (For Loved One)</td>
                  <td className="cell3 even">
                    {appointmentDetails?.bookedby != "-"
                      ? appointmentDetails?.bookedby
                      : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Gender</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientGender}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Date Of Birth</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientDob ? (
                      <>
                        {(() => {
                          const dob = appointmentDetailsV2.patientDob;
                          const dobDate = new Date(dob);
                          const currentDate = new Date();
                          const ageInMonths = Math.floor(
                            (currentDate - dobDate) /
                              (1000 * 60 * 60 * 24 * 30.4375)
                          ); // Average number of days in a month
                          const ageInYears = Math.floor(ageInMonths / 12);

                          const formattedDob = new Intl.DateTimeFormat(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                            .format(dobDate)
                            .replace(/ /g, "/");

                          if (ageInMonths < 1) {
                            return `${formattedDob}, 1 month`;
                          } else if (ageInMonths < 12) {
                            return `${formattedDob}, ${ageInMonths} months`;
                          } else {
                            return `${formattedDob}, ${ageInYears} years`;
                          }
                        })()}
                      </>
                    ) : (
                      ""
                    )}
                    {console.log("Dob", appointmentDetailsV2?.patientDob)}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Address</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientaddress || "NA"}
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 even">Browser</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientBrowser || "NA"}
                  </td>
                </tr> */}

                {/* <tr>
                  <td className="cell1 even">Browser Version</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientVersion || "NA"}
                  </td>
                </tr> */}
                {/* 
                <tr>
                  <td className="cell1 even">OS</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientOs || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">User Agent</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.userAgent || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">App Version</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.appVersion || "NA"}
                  </td>
                </tr> */}
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={6}>
                    Doctor Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Doctor ID</td>
                  <td className="cell3 odd">{appointmentDetailsV2?.DoctorId}</td> 
                </tr>

                <tr>
                  <td className="cell1 even">Name</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctorname}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Speciality</td>
                  <td className="cell3 odd">
                    {`${appointmentDetailsV2?.speciality}${
                      appointmentDetails.subSpeciality &&
                      appointmentDetails.subSpeciality !== "Not Available" &&
                      appointmentDetails.subSpeciality !== "Rheumatology"
                        ? ` - ${appointmentDetails.subSpeciality}`
                        : ""
                    }`}
                  </td>
                </tr>
                 <tr>
                  <td className="cell1 odd">Department Name</td>
                  <td className="cell3 odd">
                    {appointmentDetailsV2?.departmentName ||"NA"}
                        
                  </td>
                </tr>

                {/* <tr>
                            <td className='cell1 even'>Hospital Name</td>
                            <td className='cell3 even'>Ganga Hos</td>
                        </tr> */}

                <tr>
                  <td className="cell1 odd">Email ID</td>
                  <td className="cell3 odd">
                    {appointmentDetailsV2?.DoctorEmail}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Phone Number</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.DoctorMobile}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Alternate Number</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctrAlternateNumber || "NA"}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Gender</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctorGender}
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 even">DOB</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctorDob ? (
                      <>
                        {(() => {
                          const dob = appointmentDetailsV2.doctorDob;
                          const dobDate = new Date(dob);
                          if (isNaN(dobDate.getTime())) {
                            return "NA";
                          }
                          const currentDate = new Date();
                          const ageInMonths = Math.floor(
                            (currentDate - dobDate) /
                              (1000 * 60 * 60 * 24 * 30.4375)
                          );
                          const ageInYears = Math.floor(ageInMonths / 12);

                          const formattedDob = new Intl.DateTimeFormat(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                            .format(dobDate)
                            .replace(/ /g, "/");

                          if (ageInMonths < 1) {
                            return `${formattedDob}, 1 month`;
                          } else if (ageInMonths < 12) {
                            return `${formattedDob}, ${ageInMonths} months`;
                          } else {
                            return `${formattedDob}`;
                          }
                        })()}
                      </>
                    ) : (
                      ""
                    )}
                    {console.log("Dob", appointmentDetailsV2?.doctorDob)}
                  </td>
                </tr> */}

                {/* <tr>
                  <td className="cell1 even">Browser</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctorBrowser || "NA"}
                  </td>
                </tr> */}

                {/* <tr>
                  <td className="cell1 even">Browser Version</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientVersion || "NA"}
                  </td>
                </tr> */}

                {/* <tr>
                  <td className="cell1 even">OS</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.doctorOS || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">User Agent</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.userAgent || "NA"}
                  </td>
                </tr> */}
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Fees Calculation
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Status</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.paymentStatus != "-"
                      ? appointmentDetails?.paymentStatus
                      : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Payment ID</td>
                  <td className="cell3 even">
                    {appointmentDetails?.paymentId || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Payment Date & Time</td>
                  <td className="cell3 even">
                    {appointmentDetails?.fees ===
                    "Fees not available - Booked by admin"
                      ? "NA"
                      : appointmentDetails?.paymentDatetime || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Refund ID</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.refundid || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Fees Paid</td>
                  <td className="cell3 even">{appointmentDetails?.fees}</td>
                </tr>

                <tr>
                  <td className="cell1 odd">Payment Mode</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.paymentgatway}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Invoice file</td>
                  <td className="cell3 even">
                    {appointmentDetails?.invoice &&
                    appointmentDetails?.invoice !== "Not Available" ? (
                      <a href={appointmentDetails.invoice} target="_blank">
                        Invoice
                      </a>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <AcceptModal
            isReassign
            open={acceptModal}
            togggle={toggleAcceptModal}
            onOk={() => {}}
            appointmentData={requestedData}
            setProcessdone={setProcessdone}
            successCallback={handleAcceptModalCallBack}
            appointmentDetailsV2={appointmentDetailsV2}
            
          />
        </>
      ) : (
        <div className="loader" style={{ width: "100%", textAlign: "center" }}>
          <Skeleton active />
        </div>
      )}
    </div>
  );
}

export default TodaysReportModalContent;
const ActionButtons = ({ onAccept, onReject }) => {
  return (
    <div className="actionbtn" style={{ width: "100%" }}>
      <button
        onClick={onAccept}
        style={{
          background: "#013660",
          borderColor: "#013660",
          color: "#fff",
          width: "100%",
          height: "50px",
          fontSize: "18px",
          borderRadius: "5px",
        }}
      >
        Reschedule
      </button>
    </div>
  );
};

const AcceptModal = ({
  open,
  togggle,
  isReassign,
  reAssignData,
  setReassignData,
  appointmentData,
  setProcessdone,
  successCallback,
  appointmentDetailsV2
}) => {
  let [timeSlots, setTimeSlots] = useState();
  const [form] = Form.useForm();
  let [doctors, setDoctors] = useState();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState();
  let [loading, setLoding] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  useEffect(() => {
    checUser();
    console.log("requestedData", appointmentData);
    if (appointmentData != undefined) {
      console.log("requestedData", appointmentData.doctorId);
      /*dispatch(
        fetch_doctors_list("Ganga Hospital", appointmentData.doctorId)
      ).then((res) => {
        console.log("res", res);
        setDoctors(res);
      });*/
      fetchDoctors(appointmentDetailsV2?.specialityId)
    } else {
      console.log("requestedData", appointmentData);
    }
    if (open) {
      handleAppointmentDateChange(
        appointmentData?.doctorappointmentdate.split(" ")[0]
      );
      form.setFieldsValue({
        appointmentDate: moment(
          appointmentData?.doctorappointmentdate.split(" ")[0]
        ),
        appointmentTime:
          appointmentData?.doctorappointmentdate.split(" ")[1] +
          " " +
          appointmentData?.doctorappointmentdate.split(" ")[2],
        doctorName: appointmentData?.doctorId,
        duration: appointmentData?.duration,
        speciality: appointmentDetailsV2?.specialityId
      });
    }
    dispatch(fetchallSpeciality("")).then((res) => {
            if (res) {
              console.log("department", res);
              const options = res.map((item) => ({
                id: item.SpecialityId,
                name: item.specialityName,
              }));
              setSpecialities(options);
            }
          });
  }, [open]);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open]);

  const fetchDoctors = async (selectedDoctorValue) => {
      try {
        const consultationData = await dispatch(
          getdoctorbyspeciality(selectedDoctorValue,"Ganga Hospital")
        );
        setDoctors(consultationData);
        console.log("consultationData",consultationData)
        // Reset the doctor selection when speciality changes
       
      } catch (error) {
        console.error("Error fetching consultation and timezone data:", error);
      }
    };
  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserId(JSON.parse(res).userId);
    });
  };
  const getdoctorslis = () => {
    let doctorslist = [];
    if (doctors != undefined && doctors.length > 0) {
      doctors.map((eachAppointment, key) => {
        doctorslist.push({
          value: eachAppointment.doctorName,
          option: eachAppointment.doctorId,
        });
      });
    }
    return doctorslist;
  };

  const getConditionalText = (key) => {
    switch (key) {
      case "formCaption":
        return isReassign ? "Select" : "Select";
      case "submitText":
        return isReassign ? "Submit" : "Assign";
      case "successMessage":
        return "Updated";
      default:
        break;
    }
  };

  function handleAppointmentDateChange(e) {
    console.log("e", e);
    if (e != null) {
      let _timeSlots = createTimeSlots(e);
      setTimeSlots(_timeSlots);
    } else {
      setTimeSlots([]);
    }
  }

  function handleFormFinish(data) {
    setLoding(true);
    console.log("data", data);
    const momentObject = moment(data.appointmentDate, "DD-MMM-YYYY");
    console.log(
      "momentObject",
      momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime
    );
    console.log("appointmentData", appointmentData);

    let param = {
      process: "accept",
      appointmentId: appointmentData.appointmentId,
      UserId: userId,
      doctorId: data.doctorName,
      alternateDate: momentObject.format("DD-MMM-YYYY"),
      appoitmenttime: data.appointmentTime,
      duration: data.duration,
      timezone: appointmentData.timezone,
    };

    dispatch(getupdtappoinment(param)).then((res) => {
      console.log("res", res);
      if (
        res.info ===
        "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience."
      ) {
        message.success(
          `Time slot already chosen by some other person. Please try with different slot, Sorry for the inconvenience.`
        );
        setLoding(false);
      } else {
        setLoding(false);
        message.success(
          `Appointment ${getConditionalText("successMessage")} successfully`
        );
        togggle(false);
        setProcessdone(true);
        if (successCallback) {
          successCallback();
        }
      }
    });
  }
  const { Option } = Select;

  return (
    <Modal
      className={`${styles.customModal} ${styles.customModalAccept}`}
      footer={false}
      closeIcon={<></>}
      header={null}
      open={open}
    >
      <Form
        form={form}
        onFinish={handleFormFinish}
        className={styles.accept_form}
      >
        <div className={styles.modalBody}>
          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the appointment date{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="appointmentDate"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Date",
                  },
                ]}
              >
                <DatePicker
                  format="DD-MMM-YYYY"
                  disabledDate={(current) =>
                    current.isBefore(moment().subtract(1, "day"))
                  }
                  onChange={handleAppointmentDateChange}
                />
              </Form.Item>
            </div>
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the appointment time{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="appointmentTime"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Time",
                  },
                ]}
              >
                <Select
                  options={createDropdownValues(timeSlots)}
                  allowClear
                  placeholder="Select time"
                />
              </Form.Item>
            </div>
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              Enter the duration <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="duration"
                rules={[
                  {
                    required: true,
                    message: "*Please Enter Duration",
                  },
                ]}
              >
                <Input
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="Enter Duration"
                  maxLength={3}
                  className={styles.antinput}
                />
              </Form.Item>
            </div>
          </div>
          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the speciality{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="speciality"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Speciality",
                  },
                ]}
              >
                
                <Select 
                  placeholder="Select Speciality"
                  onChange={(e) => {
                    fetchDoctors(e)
                     form.setFieldsValue({
                      doctorName: undefined
                    });
                  }}
                >
                  {specialities != undefined &&
                    specialities.map((option) => (
                      <Option key={option.id} value={option.id}>
                        {option.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the doctor{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="doctorName"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Doctor",
                  },
                ]}
              >
                
                <Select placeholder="Select Doctor">
                  {doctors != undefined &&
                    doctors.map((option) => (
                      <Option key={option.doctorId} value={option.doctorId}>
                        {option.doctorName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            type="button"
            className={styles.closeModalBtn}
            onClick={() => {
              togggle(false);
            }}
          >
            Close
          </button>
          <button
            type="submit"
            className={styles.acceptModalBtn}
            style={{
              background: "#013660",
              borderColor: "#013660",
              color: "#fff",
            }}
            disabled={loading}
          >
            {loading ? "Please wait.." : getConditionalText("submitText")}
          </button>
        </div>
      </Form>
    </Modal>
  );
};
